// extracted by mini-css-extract-plugin
export default {"section":"SettingsSection-module__section--JGxVR","header":"SettingsSection-module__header--o29oi"};